import clsx from "clsx"
import { useField } from "formik"
import type { FieldHookConfig } from "formik"
import React from "react"

interface TextInputProps {
  label?: string
  placeholder?: string
}

const PressTextInput = (props: TextInputProps & FieldHookConfig<string>) => {
  // https://stackoverflow.com/questions/61089182/how-to-properly-use-usefield-hook-from-formik-in-typescript
  const [field, meta] = useField(props)
  return (
    <>
      <input
        {...field}
        placeholder={props?.placeholder}
        type={props?.type}
        className={clsx(
          "bg-gray-80 h-[76px] w-full rounded-lg body2 text-gray-2.5 p-6 text-gray-30::placeholder mb-6",
          meta?.touched && meta?.error
            ? "ring-error-100 ring-2 border-opacity-0"
            : "border-gray-70 border-2",
        )}
      />
      {meta?.touched && meta?.error ? (
        <div className="mb-6 -mt-4 text-xs font-bold error text-error-100">
          {meta?.error}
        </div>
      ) : null}
    </>
  )
}

export default PressTextInput
